import { landingPageLayoutsWithEntity, landingPageIncludes } from '@/modules/config/campaign'
import router from '../../router'
import LandingPage from '@/modules/api/landingPage'

const state = {
  landingPage: {},
  layout: '',
  landingPageIncluded: []
}

const mutations = {
  setLandingPage (state, object) {
    state.landingPage = object
  },

  setLandingPageLayout (state, string) {
    state.layout = string
  },

  setLandingPageIncluded (state, array) {
    state.landingPageIncluded = array
  }
}

const actions = {
  async fetchLandingPageLayout ({ commit, state }, args) {
    const url = `${args.id}/layout`
    const landingPageApi = new LandingPage()

    try {
      const response = await landingPageApi.get(url)
      if (response) {
        commit('setLandingPageLayout', response.data.attributes.layout)

        if (landingPageLayoutsWithEntity.includes(response.data.attributes.layout)) {
          commit('setEntityType', response.data.type)
          commit('setEntitySlug', response.data.attributes['slug-url'])
        }
      }
    } catch (error) {
      commit('setNotification', {
        type: 'error',
        msg: error.response.data.errors[0].meta.message
      })
      router.push({ path: '/', query: { messageType: 'error', message: error.response.data.errors[0].meta.message } })
    }
  },

  async fetchLandingPage ({ commit, state }, args) {
    let include = ''
    const landingPageApi = new LandingPage()

    if (landingPageIncludes[state.layout]) {
      include = `?include=${landingPageIncludes[state.layout]}`
    }
    const url = `${args.id}${include}`

    try {
      const response = await landingPageApi.get(url)
      if (response) {
        commit('setLandingPage', response.data)
        commit('setLandingPageIncluded', response.included)
      }
    } catch (error) {
      commit('setNotification', {
        type: 'error',
        msg: error.response.data.errors[0].meta.message
      })
      router.push({ path: '/', query: { messageType: 'error', message: error.response.data.errors[0].meta.message } })
    }
  },

  async submitSubscriber ({ commit, state }, args) {
    const url = `/api/v2/email_lists/${state.landingPage.attributes['email-list-id']}`

    try {
      const response = await window.axios.put(url, args)
      if (response) return response
    } catch (error) {
      commit('setNotification', {
        type: 'error',
        msg: error.response.data.errors[0].meta.message
      })
    }
  }
}

export default {
  state,
  mutations,
  actions
}
